import { OrganisationApiBase } from '@/libs/apis/organisation/base';

export class OrganisationGroupBoostApi extends OrganisationApiBase {
  get(id) {
    return super.get(`boost/${id}/`, 'Could not retrieve boost details');
  }
}
